import React, { useEffect, useState } from 'react';

import { Link, Stack, Typography } from '@mui/material';

import { BUSINESS_TRAVELLER_ROLES as RoleMap } from '~/consts/businessTravellerRoles';

import { getBusiness, getEmployee } from '~/services/BusinessTraveller/BusinessTravellerService';

function BusinessTravellerBusinessLabel({ customer }: { customer: App.User }) {
  const [business, setBusiness] = useState<App.Business>();
  const [employee, setEmployee] = useState<App.BusinessEmployee>();

  async function fetchBusinessByCustomerId(customerId: string) {
    try {
      const employee = await getEmployee(customerId);
      if (employee) {
        setEmployee(employee);
        const business = await getBusiness(employee.businessId);
        if (business) {
          setBusiness(business);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }

  useEffect(() => {
    fetchBusinessByCustomerId(customer.id_member);
  }, [customer.id_member]);

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Typography variant="h6" fontWeight={500}>
        Business:
      </Typography>
      {business && (
        <Link variant="h6" fontWeight={500} href={`/lebusiness/${business.id}/business`}>
          {business.name}
        </Link>
      )}
      {!business && <Typography variant="h6">This user is not associated with a business</Typography>}
      {employee && employee.roles.length > 0 && (
        <>
          <Typography variant="h6" fontWeight={500} sx={{ ml: 2 }}>
            Role:
          </Typography>
          <Typography variant="h6">
            {employee.roles.map((role) => RoleMap[role as keyof typeof RoleMap] || role).join(', ')}
          </Typography>
        </>
      )}
    </Stack>
  );
}

export default BusinessTravellerBusinessLabel;
